import styled from "styled-components"

import { Skeleton, spacing, Text } from "@minuthq/meatball-ui-react"

import { TPropertyContext } from "src/data/propertyContext/propertyContextTypes"
import { useGetUser } from "src/data/user/hooks/useGetUser"
import { useFetchUser } from "src/data/user/queries/userQueries"
import { useTranslate } from "src/i18n/useTranslate"
import { formatDate } from "src/utils/l10n"

export function AiAssistantContextMeta({
  context,
}: {
  context: TPropertyContext
}) {
  const { tPlaceholder } = useTranslate()

  const user = useGetUser()

  const fetchCreatedByUser = useFetchUser({
    userId: context.created_by,
  })

  const fetchUpdatedByUser = useFetchUser({
    userId: context.updated_by,
  })

  return (
    <MetaWrapper>
      <Meta>
        <Text variant="bodyS" color="secondary">
          {tPlaceholder("Created")}:
        </Text>
        <Text variant="bodyS" color="secondary">
          {formatDate({
            date: context.created_at,
            clockType: user.clock_type,
          })}
        </Text>
      </Meta>

      <Meta>
        <Text variant="bodyS" color="secondary">
          {tPlaceholder("Created by")}:
        </Text>
        {fetchCreatedByUser.isLoading ? (
          <Skeleton width="10ch" variant="rect" height="16px" />
        ) : (
          <Text variant="bodyS" color="secondary">
            {fetchCreatedByUser.data?.fullname}
          </Text>
        )}
      </Meta>

      <Meta>
        <Text variant="bodyS" color="secondary">
          {tPlaceholder("Last updated")}:
        </Text>
        <Text variant="bodyS" color="secondary">
          {formatDate({
            date: context.updated_at,
            clockType: user.clock_type,
          })}
        </Text>
      </Meta>

      <Meta>
        <Text variant="bodyS" color="secondary">
          {tPlaceholder("Last updated by")}:
        </Text>
        {fetchUpdatedByUser.isLoading ? (
          <Skeleton width="10ch" variant="rect" height="16px" />
        ) : (
          <Text variant="bodyS" color="secondary">
            {fetchUpdatedByUser.data?.fullname}
          </Text>
        )}
      </Meta>
    </MetaWrapper>
  )
}

const MetaWrapper = styled.div`
  display: grid;
  gap: ${spacing.XS};
`

const Meta = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: ${spacing.XS2};
`
